module.exports = __webpack_public_path__ + "img/IC_Msg_Alert.d2edef9e.svg";